module.exports = __webpack_public_path__ + "static/media/shutter-sobre@3x.19166f45.png";